export const SECTION_TITLE_SIMILAR_NEW_CARS = 'Similar New Cars';
export const SECTION_TITLE_SIMILAR_USED_CARS = 'Similar Used Cars';

export const NEW_CARS_COMPARE_LIST_LOCAL_STORAGE_KEY = 'newCarsCompareList';
